export class ValeurCible {
    annee: any;
    valeur_cible: any;
    valeur_cible_id: any
  
  
  }